import AlertModalComponent from './AlertModal.component';

export * from './AlertModal.component';
export default AlertModalComponent;
